export interface IUser {
    CurrentBank?: string;
    OFS?: string;
    abianagrafico?: string;
    cabanagrafico?: string;
    attributes?: IUserAttributes;
    cognome?: string;
    exp?: number;
    iat?: number;
    idcedcorrente?: string;
    idcedcorrentedescrizione?: string;
    ip?: string;
    issuer?: string;
    matricola?: string;
    nameID?: string;
    nameIDFormat?: string;
    nome?: string;
    profilo?: string[];
    isCesarePonti?: boolean;
    isCesarePontiInBper?: boolean;
    isCesarePontiInBCP?: boolean;
    isFuoriSede?: boolean;
    isAccreditato?: boolean;
    isOFSAbilitato?: boolean;
    isOperatoreAbilitatoOFS?: boolean;
    enabled?: boolean;
}

export interface IUserAttributes {
    CurrentBank?: string;
    OFS?: string;
    abianagrafico?: string;
    cognome?: string;
    idcedcorrente?: string;
    idcedcorrentedescrizione?: string;
    ip?: string;
    matricola?: string;
    nome?: string;
    profilo?: string[];
    isCesarePonti?: boolean;
    isCesarePontiInBper?: boolean;
    isCesarePontiInBCP?: boolean;
    isFuoriSede?: boolean;
    isAccreditato?: boolean;
    isOFSAbilitato?: boolean;
    isOperatoreAbilitatoOFS?: boolean;
}

export enum EAbiBank {
    BCP = '03084',
    BPER = '05387'
}

export enum EUserFunctionality {
    W = 'W',
    R = 'R',
    HD = 'HD'
}

export type TUserFunctionality = keyof typeof EUserFunctionality;

export enum EUserVisibility {
    DG = 'DG',
    F = 'F',
    MDS = 'MDS',
    DT = 'DT'
}

export type TUserVisibility = keyof typeof EUserVisibility;
